interface IdeaCardGridSkeletonProps {
  /** How many placeholder cards to show. */
  count?: number
  /** Tailwind grid-template classes, so each surface can match its own columns. */
  gridClassName?: string
  className?: string
}

const DEFAULT_GRID =
  'grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 xl:grid-cols-3 xl:gap-5'

/**
 * Shared placeholder grid for any surface that lists idea cards (explore,
 * home live ideas, dashboard tabs, profile). Keeps the loading look identical
 * everywhere. Pair with `useLoaderPhase` so it only appears on slow loads, and
 * with `page-route-enter` so it crossfades in.
 */
export function IdeaCardGridSkeleton({
  count = 6,
  gridClassName = DEFAULT_GRID,
  className,
}: IdeaCardGridSkeletonProps) {
  return (
    <div
      aria-busy
      aria-label="Loading ideas"
      className={`page-route-enter ${gridClassName} [&>*]:overflow-visible${
        className ? ` ${className}` : ''
      }`}
    >
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          aria-hidden
          className="h-[216px] w-full min-w-0 animate-pulse rounded-[16px] border border-white/[0.06] bg-white/[0.03]"
        />
      ))}
    </div>
  )
}
